import { Fragment } from "react/jsx-runtime";

import { Box, Divider, Typography } from "@mui/material";
import { Tooltip } from "@mui/material";

import { AIRLINE_IMG } from "@/constants/airline";
import { AIRPORT_MAP } from "@/constants/airport";
import { airlineBgColor } from "@/constants/config";
import useThemeData from "@/hooks/useThemeData";
import { FlightItem, Product } from "@/typings";

import usePlatform from "../usePlatform";

interface ProductsProps {
  data: FlightItem;
}

const airportDisplay = (airport_code: string) => {
  const airportData = AIRPORT_MAP[airport_code.toUpperCase()];
  return airportData ? airportData.name : "Unknown Name";
};

const formatTime = (minutes: number) => {
  if (minutes > 60) {
    return `${Math.floor(minutes / 60)}hr${minutes % 60 ? ` ${minutes % 60}min` : ""}`;
  } else {
    return `${minutes}min`;
  }
};

const Point = () => {
  const theme = useThemeData();
  const pointColor = theme.isDarkMode ? airlineBgColor : "#e1f5fe";
  return <div className="size-[8px] rounded-full flex-shrink-0" style={{ border: "1px solid " }} />;
};

const Logo = (props: { url: string }) => {
  return <img className="size-[16px]" src={props.url} alt="" />;
};

const getLogoUrl = (data: Product) => {
  return data.airline_name?.indexOf("&") !== -1
    ? AIRLINE_IMG["MXA"]
    : AIRLINE_IMG[data.airline_code];
};

const Products = (props: ProductsProps) => {
  const products = props.data?.fare?.products ?? [];
  const theme = useThemeData();
  const { isMobile } = usePlatform();
  return (
    <Box>
      <div className="flex items-center justify-between">
        <div className="flex justify-between mb-[-2px]">
          <Tooltip title={airportDisplay(products[0].origin)} placement="top">
            <Typography className="pr-[6px]" fontSize={18}>
              {products[0].origin}
            </Typography>
          </Tooltip>
        </div>

        {products.length <= 3 ? (
          products.map((item, index) => {
            return (
              <Fragment key={index}>
                {index > 0 && (
                  <div className="relative flex-shrink-0 flex flex-col items-center justify-center">
                    <Tooltip
                      title={
                        airportDisplay(products[index - 1].destination) +
                        " (" +
                        products[index - 1].destination +
                        ")" +
                        (products[index - 1].destination != products[index].origin
                          ? "\n / " +
                            airportDisplay(products[index].origin) +
                            " (" +
                            products[index].origin +
                            ")"
                          : "")
                      }
                      placement="top"
                    >
                      <Typography
                        style={{
                          border: theme.isDarkMode
                            ? "1px solid rgba(255, 255, 255, 0.7)"
                            : "1px solid rgba(0, 0, 0, 0.45)",
                          borderRadius: "4px",
                          padding: "0 4px",
                          height: "22px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {products[index - 1].destination == products[index].origin
                          ? products[index - 1].destination
                          : products[index - 1].destination + " / " + products[index].origin}
                      </Typography>
                    </Tooltip>
                    <Typography fontSize={12} className="absolute top-[25px] whitespace-nowrap">
                      +{formatTime(products[index - 1].layover_time)}
                    </Typography>
                  </div>
                )}
                <Divider className="flex-1" />
                <div className="relative flex flex-col items-center justify-center">
                  <Tooltip title={item.airline_name} placement="top">
                    <div>
                      <Logo url={getLogoUrl(item)} />
                    </div>
                  </Tooltip>
                  {(!isMobile || (isMobile && products.length < 2)) && (
                    <span className="absolute top-[25px] whitespace-nowrap text-[12px]">
                      {formatTime(item.travel_minutes)}
                    </span>
                  )}
                </div>
                <Divider className="flex-1" />
              </Fragment>
            );
          })
        ) : (
          <Fragment>
            <Divider className="flex-1" />
            <Typography className="flex-shrink-0">3 stops</Typography>
            <Divider className="flex-1" />
          </Fragment>
        )}

        {/* <Point /> */}
        <Tooltip title={airportDisplay(products[products.length - 1].destination)} placement="top">
          <Typography className="pl-[6px]" fontSize={18}>
            {products[products.length - 1].destination}
          </Typography>
        </Tooltip>
      </div>
    </Box>
  );
};
export default Products;
